import axios from "axios";
axios.defaults.baseURL = "/";
axios.defaults.timeout = 60000;

export default axios;
